import { HOME_ONE_FRONTEND } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

export default () => {
  const homeOneExperiment = getExperimentOnClient(HOME_ONE_FRONTEND)

  if (homeOneExperiment.isEnabled) {
    void activateExperiment(HOME_ONE_FRONTEND)
  }
}
